export const isMarketplaceTrackerActive = (flags: any) => {
  if (Array.isArray(flags)) {
    const trackerFlag = flags.find(
      (flag) =>
        flag?.key === 'marketplaceTrackerActive' ||
        flag?.name === 'marketplaceTrackerActive'
    )

    return trackerFlag?.value === true
  }

  return flags?.marketplaceTrackerActive === true
}

export const isNewMarketplaceActive = (flags: any) => {
  if (Array.isArray(flags)) {
    const flag = flags.find(
      (f) => f?.key === 'isNewMarketplace' || f?.name === 'isNewMarketplace'
    )

    return flag?.value === true
  }

  return flags?.isNewMarketplace === true
}
